module.exports = __webpack_public_path__ + "img/title-bg.41496f27.png";